import * as Layer from "effect/Layer";

import { loadNpmrc } from "@packall/registry-npm/node";
import { Npmrc } from "../npmrc.js";

export const layerNpmrc: Layer.Layer<Npmrc> = Layer.succeed(Npmrc)({
	load: (explicitPath) => loadNpmrc({ explicitPath }),
});
